import ErrorToast, { WarnToast } from "@components/Common/ErrorTost";
import { ShowSuccessToast } from "@pages/SettingGeneral/Language/ShowSuccessToast";
import { t } from "i18next";
import {
    setDataIsUpdated,
    setIsAssociateLogoOpened,
    setIsLoading,
    setIsValidateClicked,
    setKey,
    setNumberActiveMultiShop,
    setNumberArchiveMultiShop,
} from "../store";
import { uuid } from "uuidv4";

export async function handleAssociateLogoButtonClick(
    idShops: any,
    selectedRows: any,
    salesSupports: any,
    activeLogo: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    setSelectedRows: any,
    setIsValidateClickedModal: any,
    setIsUpdatedModification: any,
    fetchGlobal: any
) {
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
    let salesSupportInShops: boolean[] = [];
    let objectData: any = {};
    let shopIds: any = [];
    idShops.forEach((element: any) => {
        if (selectedRows.length !== 0) {
            selectedRows.forEach(async (el: any) => {
                let salesSupportInShop: boolean = el[t("Sales support")]
                    .split(",")
                    .some(
                        (r: any) =>
                            salesSupports
                                .find((elt: any) => elt.id === element)
                                .salesSupport.indexOf(r) >= 0
                    );
                salesSupportInShops.push(salesSupportInShop);
                if (salesSupportInShop)
                    Object.assign(objectData, {
                        [el.Id]: {
                            designation: el[t("Designation")],
                            support_de_vente: el[t("Sales support")],
                            urlImage: el[t("Image")],
                            shopId: element,
                            tag: el.tag,
                            isActive: activeLogo.find(
                                (element: any) => element.id === el.Id
                            ).state,
                            isArchived: el.isArchived,
                            img: el.img,
                        },
                    });
                if (!shopIds.includes(element)) {
                    shopIds.push(element);
                }
            });
        }
    });

    if (Object.keys(objectData).length > 0) {
        let dataLogo = {
            affectation: true,
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: objectData,
        };

        const data = new FormData();
        data.append("dataLogo", JSON.stringify(dataLogo));
        data.append("image", "");
        const requestOptions = {
            method: "POST",
            body: data,
        };

        try {
            const result = await fetchGlobal(apiUrl, requestOptions);

            if (!result.error) {
                setKey(uuid());
                ShowSuccessToast(`${t("The reassignment was successful")}`);
                setDataIsUpdated(true);
                setSelectedRows([]);
                setIsValidateClickedModal(false);
                setIsUpdatedModification(false);
                setIsValidateClicked(true);
            } else {
                throw Error(result.message);
            }
        } catch (e) {
            ErrorToast(`${e}`);
        }
    }
}

export async function handleStateChange(
    dataState: boolean,
    shopsLogoData: any,
    selectedRowData: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    choiceState: boolean,
    fetchGlobal: any
) {
    let updatedLogo: any = {};
    let shopLogo: any = [];
    setIsLoading(true);
    shopsLogoData.forEach((element: any) => {
        if (element.shopId === selectedRowData.selectedRow.shopId) {
            shopLogo = element.subRows;
        }
    });
    let id = selectedRowData?.selectedRow.Id;

    shopLogo.forEach((logo: any) => {
        if (id === logo.Id) {
            Object.assign(updatedLogo, {
                [id]: {
                    designation: selectedRowData?.selectedRow[t("Designation")],
                    tag: selectedRowData?.selectedRow.tag,
                    shopId: selectedRowData?.selectedRow.shopId,
                    isArchived: selectedRowData?.selectedRow.isArchived,
                    isActive: dataState,
                    support_de_vente:
                        selectedRowData.selectedRow[t("Sales support")],
                    urlImage: selectedRowData.selectedRow[t("Image")],
                    img: selectedRowData?.selectedRow.img,
                },
            });
        } else if (dataState === true && logo.isActive === true) {
            Object.assign(updatedLogo, {
                [logo.Id]: {
                    designation: logo[t("Designation")],
                    tag: logo.tag,
                    shopId: logo.shopId,
                    isArchived: logo.isArchived,
                    isActive: false,
                    support_de_vente: logo[t("Sales support")],
                    urlImage: logo[t("Image")],
                    img: logo.img,
                },
            });
        }
    });
    let dataLogo = {
        userId: userID,
        shopId: [selectedRowData?.selectedRow.shopId],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        data: updatedLogo,
    };
    const isStateChange = dataState;
    const data = new FormData();
    data.append("dataLogo", JSON.stringify({ dataLogo, isStateChange }));
    data.append("image", "");
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
    const requestOptions = {
        method: "POST",
        body: data,
    };

    const result = await fetchGlobal(apiUrl, requestOptions);
    if (result.error) {
        throw Error(result.message);
    }
    setKey(uuid());
    setDataIsUpdated(true);
    ShowSuccessToast(
        !choiceState
            ? `${t("logo has been successfully activated")}`
            : `${t("logo has been successfully deactivated")}`
    );

    setIsLoading(false);
}

export async function isSaleSupportArchived(
    selectedRowData: any,
    userID: any,
    franchiseID: any,
    uuidUser: any,
    i18nextLng: any,
    fetchGlobal: any
) {
    let isSaleSupportArchived = false;
    try {
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport?userId=${userID}&franchiseId=${franchiseID}&type=archived&uuidUser=${uuidUser}`;
        const data = await fetchGlobal(url, {
            method: "GET",
            headers: {
                "Accept-Language": i18nextLng,
            },
        });
        data.data.forEach((elt: any) => {
            selectedRowData.selectedRow[t("Sales support")]
                .split(",")
                .forEach((support: any) => {
                    if (
                        elt.subRows.some(
                            (sale: any) =>
                                `${sale[t("Support de vente")]} ${
                                    sale.shopId
                                }` ===
                                `${support} ${selectedRowData.selectedRow.shopId}`
                        )
                    ) {
                        isSaleSupportArchived = true;
                    }
                });
        });
    } catch (error) {
        console.log(error);
        throw error;
    }
    return isSaleSupportArchived;
}

export async function handleActiveLogo(
    selectedRowData: any,
    numberActiveMultiShop: any,
    numberArchiveMultiShop: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    setIsClicked: any,
    fetchGlobal: any
) {
    setIsClicked(false);
    let dataLogo = {
        userId: userID,
        shopId: [selectedRowData.selectedRow.shopId],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        isShop: true,
        data: {
            [selectedRowData.selectedRow.Id]: {
                designation: selectedRowData.selectedRow[t("Designation")],
                support_de_vente:
                    selectedRowData.selectedRow[t("Sales support")],
                urlImage: selectedRowData.selectedRow[t("Image")],

                shopId: selectedRowData.selectedRow.shopId,

                tag: selectedRowData.selectedRow.tag,
                isActive: false,
                isArchived: false,
                img: selectedRowData?.selectedRow.img,
            },
        },
    };
    const data = new FormData();
    data.append("dataLogo", JSON.stringify(dataLogo));
    data.append("image", "");

    const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
    const requestOptions = {
        method: "POST",

        body: data,
    };
    try {
        const data = await fetchGlobal(apiUrlAdd, requestOptions);
        if (data.error) {
            throw Error("error");
        }
        setKey(uuid());
        ShowSuccessToast(`${t("logo has been successfully activated")!}`);
        setIsLoading(false);
        setDataIsUpdated(true);
        setNumberActiveMultiShop(numberActiveMultiShop + 1);
        setNumberArchiveMultiShop(numberArchiveMultiShop - 1);
        setIsClicked(true);
    } catch (e: any) {
        ErrorToast(`${e}`);
        setIsLoading(false);
    }
}

export async function handleArchiveLogo(
    selectedRowData: any,
    setIsClicked: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    numberActiveMultiShop: any,
    numberArchiveMultiShop: any,
    fetchGlobal: any
) {
    setIsLoading(true);
    setIsClicked(false);
    let dataLogo = {
        userId: userID,
        shopId: [selectedRowData?.shopId],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        data: {
            [selectedRowData?.Id]: {
                designation: selectedRowData[t("Designation")],
                support_de_vente: selectedRowData[t("Sales support")],
                urlImage: selectedRowData[t("Image")],
                shopId: selectedRowData?.shopId,
                tag: selectedRowData?.tag,
                isActive: false,
                isArchived: true,
                img: selectedRowData?.img,
            },
        },
    };
    const data = new FormData();
    data.append("dataLogo", JSON.stringify(dataLogo));
    data.append("image", "");
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;

    const requestOptions = {
        method: "POST",
        body: data,
    };

    const result = await fetchGlobal(apiUrl, requestOptions);
    if (result.error) {
        throw Error(result.message);
    }
    setKey(uuid());
    ShowSuccessToast(`${t("The logo is successfully archived")}`);
    setIsLoading(false);
    setDataIsUpdated(true);
    setNumberActiveMultiShop(numberActiveMultiShop - 1);
    setNumberArchiveMultiShop(numberArchiveMultiShop + 1);
    setIsClicked(true);
}

export async function archiveLogo(
    getArrayOfRows: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    fetchGlobal: any
) {
    setIsValidateClicked(false);
    let shopIds: any = [];
    let dataLogos: any = {};
    let arrayOfRows = getArrayOfRows();
    arrayOfRows.forEach(async (el: any) => {
        if (!shopIds.includes(el.shopId)) {
            shopIds.push(el.shopId);
        }
        dataLogos[el.Id] = {
            designation: el[t("Designation")],
            support_de_vente: el[t("Sales support")],
            urlImage: el[t("Image")],
            shopId: el.shopId,
            tag: el.tag,
            isActive: false,
            isArchived: true,
            img: el.img,
        };
    });

    let dataLogo = {
        userId: userID,
        shopId: shopIds,
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        data: dataLogos,
    };
    const data = new FormData();
    data.append("dataLogo", JSON.stringify(dataLogo));
    data.append("image", "");
    const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;

    try {
        const result = await fetchGlobal(apiUrlAdd, {
            method: "POST",
            body: data,
        });
        if (result.error === false) {
            setKey(uuid());
            ShowSuccessToast(`${t("The logo is successfully archived")!}`);
            setIsLoading(false);
            setIsValidateClicked(true);
            setDataIsUpdated(true);
        }
    } catch (e) {
        ErrorToast(`${e}`);
        setIsLoading(false);
    }
}

export async function activeLogo(
    getArrayOfRows: any,
    uuidUser: any,
    operatorID: any,
    franchiseID: any,
    userID: any,
    fetchGlobal: any
) {
    setIsValidateClicked(false);
    let dataLogos: any = {};
    let shopIds: any = [];
    let arrayOfRows = getArrayOfRows();
    arrayOfRows.forEach(async (el: any) => {
        if (!shopIds.includes(el.shopId)) {
            shopIds.push(el.shopId);
        }
        dataLogos[el.Id] = {
            designation: el[t("Designation")],
            support_de_vente: el[t("Sales support")],
            urlImage: el[t("Image")],
            shopId: el.shopId,
            tag: el.tag,
            isActive: false,
            isArchived: false,
            img: el.img,
        };
    });

    let dataLogo = {
        userId: userID,
        shopId: shopIds,
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        data: dataLogos,
    };
    const data = new FormData();
    data.append("dataLogo", JSON.stringify(dataLogo));
    data.append("image", "");
    const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;

    try {
        const result = await fetchGlobal(apiUrlAdd, {
            method: "POST",
            body: data,
        });
        if (result.error === false) {
            setKey(uuid());
            ShowSuccessToast(`${t("logo has been successfully activated")!}`);
            setIsLoading(false);
            setIsValidateClicked(true);
            setDataIsUpdated(true);
        }
    } catch (e) {
        ErrorToast(`${e}`);
        setIsLoading(false);
    }
}

export async function handleAssociateLogoButton(
    isValidateButtonDisabled: any,
    setIsValidateButtonDisabled: any,
    selectedShopsRows: any,
    selectedRows: any,
    salesSupports: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    activeLogo: any,
    isStateChanged: any,
    setSelectedRows: any,
    setIsValidateClickedModal: any,
    setIsUpdatedModification: any,
    isAssociateLogoOpened: any,
    fetchGlobal: any
) {
    setIsLoading(true);
    let shopIds: any = [];
    let salesSupportInShops: boolean[] = [];
    if (isValidateButtonDisabled === false) {
        setIsValidateButtonDisabled(true);
        let objectData: any = {};
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
        for (let element of selectedShopsRows) {
            if (selectedRows.length !== 0 && element[t("Shop")] !== undefined) {
                selectedRows.forEach(async (el: any) => {
                    let salesSupportInShop: boolean = el[t("Sales support")]
                        .split(",")
                        .some(
                            (r: any) =>
                                salesSupports
                                    .find(
                                        (elt: any) => elt.id === element.shopId
                                    )
                                    .salesSupport.indexOf(r) >= 0
                        );
                    salesSupportInShops.push(salesSupportInShop);
                    let filteredSalesSupport: any = el[t("Sales support")]
                        .split(",")
                        .filter((value: any) =>
                            salesSupports
                                .find((el: any) => el.id === element.shopId)
                                .salesSupport.includes(value)
                        )
                        .join(",");

                    if (salesSupportInShop) {
                        Object.assign(objectData, {
                            [el.Id]: {
                                designation: el[t("Designation")],
                                support_de_vente: filteredSalesSupport,
                                urlImage: el.Image,
                                shopId: element.shopId,
                                tag: el.tag,
                                isActive: activeLogo.find(
                                    (element: any) => element.id === el.Id
                                ).state,
                                isArchived: el.isArchived,
                                img: el.img,
                            },
                        });
                        if (!shopIds.includes(element.shopId)) {
                            shopIds.push(element.shopId);
                        }
                    }
                });
            }
        }

        if (Object.keys(objectData).length !== 0) {
            let dataLogo = {
                affectation: true,
                userId: userID,
                shopId: shopIds,
                franchiseId: franchiseID,
                data: objectData,
                operatorId: operatorID,
                uuidUser: uuidUser,
            };

            const data = new FormData();
            data.append("dataLogo", JSON.stringify(dataLogo));
            data.append("image", "");
            const requestOptions = {
                method: "POST",
                body: data,
            };

            try {
                const result = await fetchGlobal(apiUrl, requestOptions);

                if (!result.error) {
                    if (!salesSupportInShops.includes(true)) {
                        WarnToast(
                            t(
                                "Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings."
                            )
                        );
                    } else if (!salesSupportInShops.includes(false)) {
                        ShowSuccessToast(
                            !isStateChanged
                                ? `${t("The assignment was successful")}`
                                : `${t("The reassignment was successful")}`
                        );
                    } else if (
                        salesSupportInShops.includes(true) &&
                        salesSupportInShops.includes(false)
                    ) {
                        ShowSuccessToast(
                            !isStateChanged
                                ? `${t("The assignment was successful")}`
                                : `${t("The reassignment was successful")}`
                        );

                        WarnToast(
                            t(
                                "Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings."
                            )
                        );
                    }
                    setKey(uuid());
                    setIsAssociateLogoOpened(!isAssociateLogoOpened);
                    setDataIsUpdated(true);
                    setSelectedRows([]);
                    setIsValidateClickedModal(false);
                    setIsUpdatedModification(false);
                    setIsValidateClicked(true);
                    // setLimit(2);
                    setIsValidateButtonDisabled(false);
                    setIsLoading(false);
                } else {
                    throw Error(result.message);
                }
            } catch (e) {
                setIsLoading(false);
                ErrorToast(`${e}`);
            }
        }
    }
}
